module.exports = __webpack_public_path__ + "img/sc_slide.b3812fa3.png";